import React from 'react'
import { FieldProps } from '../../../../../../../@types/types'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import SimpleDatepicker from '../../../../../../common/inputs/datepicker/SimpleDatepicker'

const FreeFrom: React.FC<FieldProps<CostsScreenValidationResult>> = ({
  insertionData,
  screenName,
  wrapperClassName,
  onChange,
}) => {
  const id = 'free-from'
  const propertyName = 'freeFrom'
  const labelTranslationKey = 'wizard.screen.costs.freeFrom'
  const selectedDate = insertionData.freeFrom

  return (
    <SimpleDatepicker
      id={id}
      propertyName={propertyName}
      errors={[]}
      labelTranslationKey={labelTranslationKey}
      selectedDate={selectedDate}
      screen={screenName}
      wrapperClassName={wrapperClassName}
      onChange={onChange}
    />
  )
}

export default FreeFrom
